import{usePrivyEventSubscription as t}from"./events-context.mjs";import"react";function o(o){t("configureMfa",o)}export{o as useRegisterMfaListener};
